import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import IconButton from '@mui/material/IconButton';

export const MuiPopup = (props: any) => {
  const { title = "", openPopup, children, subTitleVariant, variant, onClose, subTitle, actions, disableCloseIcon = false } = props;

  return (
    <Dialog
      sx={{
        mx: 'auto'
      }}
      maxWidth='md'
      onClose={onClose}
      open={openPopup} >
      <DialogTitle>
        <Typography variant={variant}>
          {title}
        </Typography>
        <Typography variant={subTitleVariant}>
          {subTitle}
        </Typography>
        {!disableCloseIcon && <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>}
      </DialogTitle>

      <DialogContent sx={{ minWidth: 500, py: '20px' }} >
        {!!openPopup && children}
      </DialogContent>

      <DialogActions>
        {!!openPopup && actions}
      </DialogActions>
    </Dialog>
  )
}
